import { AppState } from "../store/student";

export const calcUnreadNotiCount = (state: AppState): number =>
  state.unread_comments_count +
  state.unread_feedbacks_count +
  state.unread_notification_count +
  (state.student.read_gear_release_note ? 0 : 1);
